// Indian-system number-to-words for Rupees: English + Odia.
// Handles up to 999,99,99,999 (Crores). Paise rounded to 2 decimals.

const EN_ONES = [
  "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
  "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
  "Seventeen", "Eighteen", "Nineteen",
];
const EN_TENS = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

function enUnder1000(n) {
  if (n === 0) return "";
  if (n < 20) return EN_ONES[n];
  if (n < 100) return `${EN_TENS[Math.floor(n / 10)]}${n % 10 ? " " + EN_ONES[n % 10] : ""}`;
  const h = Math.floor(n / 100);
  const r = n % 100;
  return `${EN_ONES[h]} Hundred${r ? " " + enUnder1000(r) : ""}`;
}

function enIndian(num) {
  if (num === 0) return "Zero";
  const crore = Math.floor(num / 10000000);
  const lakh = Math.floor((num % 10000000) / 100000);
  const thousand = Math.floor((num % 100000) / 1000);
  const rest = num % 1000;
  const parts = [];
  if (crore) parts.push(`${enIndian(crore)} Crore`);
  if (lakh) parts.push(`${enUnder1000(lakh)} Lakh`);
  if (thousand) parts.push(`${enUnder1000(thousand)} Thousand`);
  if (rest) parts.push(enUnder1000(rest));
  return parts.join(" ");
}

export function inWordsEN(amount) {
  const n = Math.max(0, Number(amount) || 0);
  const rupees = Math.floor(n);
  const paise = Math.round((n - rupees) * 100);
  const rupeeWords = enIndian(rupees);
  if (paise > 0) {
    return `Rupees ${rupeeWords} and ${enUnder1000(paise)} Paise Only`;
  }
  return `Rupees ${rupeeWords} Only`;
}

// ---------------- ODIA ----------------
const OR_ONES = [
  "", "ଏକ", "ଦୁଇ", "ତିନି", "ଚାରି", "ପାଞ୍ଚ", "ଛଅ", "ସାତ", "ଆଠ", "ନଅ",
  "ଦଶ", "ଏଗାର", "ବାର", "ତେର", "ଚଉଦ", "ପନ୍ଦର", "ଷୋହଳ", "ସତର", "ଅଠର", "ଊଣେଇଶି",
  "କୋଡ଼ିଏ", "ଏକୋଇଶି", "ବାଇଶି", "ତେଇଶି", "ଚବିଶି", "ପଚିଶି", "ଛବିଶି", "ସତାଇଶି", "ଅଠାଇଶି", "ଊଣତିରିଶି",
  "ତିରିଶି", "ଏକତିରିଶି", "ବତିଶି", "ତେତିଶି", "ଚଉତିରିଶି", "ପଞ୍ଚତିରିଶି", "ଛତିଶି", "ସଂଇତିରିଶି", "ଅଠତିରିଶି", "ଊଣଚାଳିଶି",
  "ଚାଳିଶି", "ଏକଚାଳିଶି", "ବୟାଳିଶି", "ତେୟାଳିଶି", "ଚଉରାଳିଶି", "ପଞ୍ଚଚାଳିଶି", "ଛୟାଳିଶି", "ସତଚାଳିଶି", "ଅଠଚାଳିଶି", "ଊଣଞ୍ଚାଶ",
  "ପଚାଶ", "ଏକାବନ", "ବାୱନ", "ତିପନ", "ଚଉରାବନ", "ପଞ୍ଚାବନ", "ଛପନ", "ସତାବନ", "ଅଠାବନ", "ଊଣଷଠୀ",
  "ଷାଠିଏ", "ଏକଷଠି", "ବାଷଠି", "ତେଷଠି", "ଚଉଷଠି", "ପଞ୍ଚଷଠି", "ଛଅଷଠି", "ସତଷଠି", "ଅଠଷଠି", "ଊଣସତୁରି",
  "ସତୁରି", "ଏକସତୁରି", "ବାସତୁରି", "ତିସତୁରି", "ଚଉସତୁରି", "ପଞ୍ଚସତୁରି", "ଛସତୁରି", "ସତସତୁରି", "ଅଠସତୁରି", "ଊଣାଅଶୀ",
  "ଅଶୀ", "ଏକାଅଶୀ", "ବୟାଅଶୀ", "ତିରାଅଶୀ", "ଚଉରାଅଶୀ", "ପଞ୍ଚାଅଶୀ", "ଛୟାଅଶୀ", "ସତାଅଶୀ", "ଅଠାଅଶୀ", "ଊଣାନବେ",
  "ନବେ", "ଏକାନବେ", "ବୟାନବେ", "ତିରାନବେ", "ଚଉରାନବେ", "ପଞ୍ଚାନବେ", "ଛୟାନବେ", "ସତାନବେ", "ଅଠାନବେ", "ଊଣାଶହ",
];

function orUnder100(n) {
  if (n === 0) return "";
  if (n < 100) return OR_ONES[n];
  return "";
}

function orUnder1000(n) {
  if (n === 0) return "";
  if (n < 100) return orUnder100(n);
  const h = Math.floor(n / 100);
  const r = n % 100;
  return `${OR_ONES[h]} ଶହ${r ? " " + orUnder100(r) : ""}`;
}

function orIndian(num) {
  if (num === 0) return "ଶୂନ୍ୟ";
  const crore = Math.floor(num / 10000000);
  const lakh = Math.floor((num % 10000000) / 100000);
  const thousand = Math.floor((num % 100000) / 1000);
  const rest = num % 1000;
  const parts = [];
  if (crore) parts.push(`${orIndian(crore)} କୋଟି`);
  if (lakh) parts.push(`${orUnder100(lakh)} ଲକ୍ଷ`);
  if (thousand) parts.push(`${orUnder100(thousand)} ହଜାର`);
  if (rest) parts.push(orUnder1000(rest));
  return parts.filter(Boolean).join(" ");
}

export function inWordsOR(amount) {
  const n = Math.max(0, Number(amount) || 0);
  const rupees = Math.floor(n);
  const paise = Math.round((n - rupees) * 100);
  const rupeeWords = orIndian(rupees);
  if (paise > 0) {
    return `${rupeeWords} ଟଙ୍କା ${orUnder100(paise)} ପଇସା ମାତ୍ର`;
  }
  return `${rupeeWords} ଟଙ୍କା ମାତ୍ର`;
}
